<template>
  <div class="tx-ktgdealersearch module-search-form">
    <div class="search-form__header" v-if="!mobile">
      <span class="heading gamma" v-html="$t('searchForm.header.' + brand)"></span>
    </div>
    <div class="search-form__form">
      <form @submit.prevent="submitForm()">
        <div class="page__wrap">
          <div class="field__tabs">
            <div class="tabs__navigation">
              <div class="navigation__item" :class="{ '-active': activeTab === 'location' }" @click="activeTab = 'location'">
                <span>{{ $t('searchForm.form.tabs.location') }}</span>
              </div>
              <div class="navigation__item" :class="{ '-active': activeTab === 'dealername' }" @click="activeTab = 'dealername'">
                <span>{{ $t('searchForm.form.tabs.dealername') }}</span>
              </div>
            </div>
            <div class="tabs__content">
              <div class="content__fields" v-show="activeTab === 'location'">
                <div class="field__wrap l-1col">
                  <div class="col">
                    <GoogleAutocomplete
                        :label="$t('searchForm.form.location.label')"
                        placeholder=""
                        :location="location"
                        :error="error"
                        @place-changed="setLocation($event)"/>
                  </div>
                </div>
              </div>
              <div class="content__fields" v-show="activeTab === 'dealername'">
                <div class="field__wrap l-1col">
                  <div class="col">
                    <KtgdealersearchAutocomplete
                        :label="$t('searchForm.form.dealername.label')"
                        placeholder=""
                        v-model:dealername="dealername"
                        :error="error"
                        @prediction-selected="openDealerLink($event)"
                        @prediction-submit="setDealername()"
                        ref="dealersearchAutocomplete" />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="actions">
            <button type="submit" class="btn -btn-alpha">
              <span>{{ $t('searchForm.form.submit') }}</span>
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import GoogleAutocomplete from '@/components/GoogleAutocomplete'
import KtgdealersearchAutocomplete from '@/components/KtgdealersearchAutocomplete'

export default {
  name: 'SearchForm',
  inject: ['detailBase', 'mobile'],
  data () {
    return {
      activeTab: 'location',
      error: false
    }
  },
  components: {
    GoogleAutocomplete,
    KtgdealersearchAutocomplete
  },
  computed: {
    ...mapState({
      brand: state => state.brand
    }),
    ...mapState({
      location: state => state.filter.location
    }),
    dealername: {
      get () {
        return this.$store.state.filter.dealername
      },
      set (value) {
        this.$store.commit('filter/setDealername', value)
      }
    }
  },
  methods: {
    ...mapActions([
      'filter'
    ]),
    ...mapActions('filter', [
      'resetCountry',
      'updateDealername',
      'resetDealername',
      'updateLocation',
      'resetLocation',
      'resetBounds'
    ]),
    setLocation (place) {
      this.updateLocation(place)
      this.resetDealername()
      this.resetBounds()
      if (place.location) this.filter()
    },
    setDealername () {
      this.resetCountry()
      this.resetLocation()
      this.resetBounds()
      this.filter()
    },
    openDealerLink (dealer) {
      window.location.href = `${this.detailBase}${dealer.slug}/?brand=${this.brand}`
    },
    submitForm () {
      this.error = !(this.location || this.dealername)
      if (this.location && this.dealername) this.dealername = ''
      if (!this.error) this.filter()
    }
  }
}
</script>
